import {Divider, Drawer, Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { useT } from 'react-polyglot-hooks';
import {Profile} from './Profile';
import navigationConfig from './navigationConfig';
import Navigation from './Navigation';
import {checkIsAdmin} from '../../../utils/checkIsAdmin';
import {getMe} from '../../../graphql/auth';
import { checkIsPrimaryPayer } from '../../../utils/checkIsPrimaryPayer';

const useStyles = (showingContactusBar: boolean) => makeStyles((theme: Theme) => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up('lg')]: {
      marginTop: 88,
      height: showingContactusBar ? 'calc(100% - 164px)' : 'calc(100% - 84px)',
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2)
  },
  navigation: {
    marginTop: theme.spacing(2)
  }
}));

const Sidebar = (
  props: {
    className?: string,
    onClose: () => any,
    open: boolean,
    variant: 'permanent' | 'persistent' | 'temporary'
  }) => {
  const { open, variant, onClose, className, ...rest } = props;
  const t = useT();
  const isAdmin = checkIsAdmin();
  const meData = getMe();
  const me = meData && meData.data && meData.data.me;
  const isCheckIsPrimaryPayer = checkIsPrimaryPayer();
  const showingContactusBar = !(!me || isAdmin);

  const classes = useStyles(showingContactusBar)();
  const navItems = navigationConfig(t, isAdmin, isCheckIsPrimaryPayer);

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div
        {...rest}
        className={clsx(classes.root, className)}
      >
        <Profile />
        <Divider className={classes.divider} />
        <nav className={classes.navigation}>
          {navItems.map(list => list && (
              <Navigation
                  component="div"
                  key={list.title}
                  pages={list.pages}
                  title={list.title}
                  onNavigationItemClick={onClose}
              />
          ))}
        </nav>
      </div>
    </Drawer>
  );
};

export default Sidebar;
